import {
  DEFAULT_EMPLOYER_OUTREACH_DATA,
  EMPLOYER_OUTREACH_FROM_VALUES,
  type EmployerOutreachData,
  type OutreachSource,
  type OutreachType,
  useEmployerOutreachContext,
} from "../context/EmployerOutreachContext";

export type { OutreachSource, OutreachType, EmployerOutreachData };
export { DEFAULT_EMPLOYER_OUTREACH_DATA };

export const useEmployerOutreachSource = (): EmployerOutreachData => {
  const { data } = useEmployerOutreachContext();
  return data;
};

export const isJobFromEmployerOutreach = (sourceUrl: string): boolean => {
  if (!sourceUrl) return false;

  const urlObj = new URL(sourceUrl);
  const fromParam = urlObj.searchParams.get("from");

  return EMPLOYER_OUTREACH_FROM_VALUES.has(fromParam ?? "");
};
